import React from "react";
import { Platform } from "react-native";

import CarouselImagesNative from "./CarouselImagesNative";
import CarouselImagesWeb from "./CarouselImagesWeb";

export type CarouselImagesProps = {
  data?: any[];
  addButtons?: boolean;
  width?: number;
  height?: number;
  addPagination?: boolean;
  renderItem?: ((args: { item: any; index: number }) => React.ReactNode) | null;
  carouselProps?: Record<string, any>;
};

const CarouselImages:React.FC<CarouselImagesProps> = (props) => {
  if (Platform.OS === "web") {
    return <CarouselImagesWeb {...props} />;
  }

  return <CarouselImagesNative {...props} />;
};

export default CarouselImages;
